import styled from "@emotion/styled";
import {
  Alignments,
  Divider,
  Heading,
  Icons,
  Label,
  MediaQueries,
  Orientations,
  Row,
  Spacer,
  Spacings,
  TextButton,
  Text,
  withOpacity,
  Colors,
  Opacities,
} from "@polestar/component-warehouse-react";
import React from "react";

import useChangelogOpenContext from "../../hooks/useChangelogOpenContext";

import { LinkButton } from "~/common/components/LinkButton";

const StyledSpacer = styled(Spacer)`
  display: inline-block;
`;

const StyledDivider = styled(Divider)`
  background: ${withOpacity(Colors.black, Opacities.xLow)};
  @media print {
    visibility: visible;
    position: absolute;
    left: 0;
    top: -${Spacings.small};
  }
`;

const StyledDiv = styled("div")`
  display: flex;
  flex-direction: column;
  ${MediaQueries.desktop} {
    flex-direction: row;
  }
`;

const StyledTextButton = styled(TextButton)`
  align-self: flex-start;
`;

const StyledHeading = styled(Heading)`
  @media print {
    visibility: visible;
    position: absolute;
    left: 0;
    top: -${Spacings.xLarge};
  }
`;

interface Props {
  readonly title: string | undefined;
  readonly version: string | undefined;
  readonly date: string | undefined;
  readonly onDownloadPdf: () => void;
  readonly dictionary: Record<string, string>;

  readonly isChangelogAvailable: boolean;
}

const ContentHeader: React.FC<Props> = ({
  title,
  dictionary,
  onDownloadPdf,
  version,
  date,
  isChangelogAvailable,
}) => {
  const changeLogContext = useChangelogOpenContext();

  return (
    <>
      <StyledHeading level={1}>{title}</StyledHeading>

      <StyledDivider spacing={Spacings.xxLarge} />
      <StyledDiv>
        <Row stretch>
          {version && (
            <>
              <Label>{version}</Label>
              <StyledSpacer
                spacing={Spacings.xSmall}
                orientation={Orientations.horizontal}
              />
            </>
          )}
          {date && (
            <>
              <Text>{date}</Text>
              <StyledSpacer
                spacing={Spacings.xSmall}
                orientation={Orientations.horizontal}
              />
            </>
          )}

          {isChangelogAvailable && (
            <LinkButton
              onClick={() => {
                changeLogContext?.setIsOpen(true);
              }}
            >
              {dictionary["What is new?"]}
            </LinkButton>
          )}
        </Row>
        <Spacer
          spacing={{
            mobile: Spacings.large,
            tablet: Spacings.large,
            desktop: Spacings.none,
          }}
        />
        <StyledTextButton
          data-testid="download-pdf-button"
          icon={Icons.download}
          iconPosition={Alignments.right}
          onClick={onDownloadPdf}
        >
          {dictionary["Download as PDF"]}
        </StyledTextButton>
      </StyledDiv>
      <Spacer
        spacing={{
          mobile: Spacings.none,
          tablet: Spacings.xxxLarge,
          desktop: Spacings.xxLarge,
        }}
      />
    </>
  );
};

export default ContentHeader;
